import { useInfiniteQuery } from '@tanstack/react-query';

import {
	SearchOrganizationByAdminRequest,
	SearchOrganisationsByAdminResponse,
	SearchOrganizationByAdminSort,
} from '@joc/api-gateway';

import { INITIAL_PAGINATION, ORGANIZATIONS_QUERY_KEY } from 'core/constants';

import { API } from 'core/API';
import { FullTextSearchOrganisationByAdmin } from '@joc/api-gateway/lib/api-client';

const fetchOrganizations = async ({
	skip,
	take,
	search,
	sort,
}: {
	skip: number;
	take: number;
	search?: FullTextSearchOrganisationByAdmin;
	sort?: SearchOrganizationByAdminSort;
}): Promise<SearchOrganisationsByAdminResponse> =>
	API.searchOrganizationsByAdmin(
		SearchOrganizationByAdminRequest.fromJS({
			pagination: {
				skip,
				take,
			},
			...(search && search.fields.length && search.value ? { fullTextSearch: search } : {}),
			...(sort && sort.sortBy && sort.sortDir ? { sort } : {}),
		})
	);

export const useOrganizations = (
	search?: FullTextSearchOrganisationByAdmin,
	sort?: SearchOrganizationByAdminSort,
	enabled = true
) =>
	useInfiniteQuery<SearchOrganisationsByAdminResponse, unknown>({
		queryKey: [ORGANIZATIONS_QUERY_KEY, { search, sort }],
		initialPageParam: 0,
		refetchOnWindowFocus: false,
		enabled,
		queryFn: ({ pageParam = 0 }) =>
			fetchOrganizations({ skip: pageParam as number, take: INITIAL_PAGINATION.take, search, sort }),
		getNextPageParam: (lastPage, allPages) => {
			return lastPage.records.length < INITIAL_PAGINATION.take ? undefined : allPages.length * 10;
		},
	});
